/*eslint no-mixed-spaces-and-tabs: "error"*/
<template>
  <div class="agenda_contents" id="create">
    <div class="main header_row">
    <template v-for="userState in users">
	    <div
	      :id="`cursor-${userState.id}`"
	      class="d-flex flex-column text-center user-cursor"
	      v-if="userState.user"
        style="z-index: 3;"
	    >
	      <i class="bi bi-cursor-fill"></i>
	      <span>{{ userState.user.name }}</span>
	    </div>
    </template>
	
	<div class="alert alert-danger alert-dismissible fixed-top-alert2" id="SaveButtonAlert2" role="alert" style="display:none;">
		<span class="alert_message" id="error_alert_message">予期しないエラーが発生しました</span>
		<button id="SaveButtonAlertContent2" type="button" class="close" data-dismiss="modal" aria-label="閉じる">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

  <div class="alert alert-warning fixed-top-alert3" id="SaveButtonAlert3" role="alert" style="display:none;">
      <span class="alert_message" id="warning_alert_message"></span>

      <footer class="footer">
        <div class="container">
        <div class="warning-text-center">
          <button type="button" id="SaveButtonWarningAlert" class="btn btn-primary save-button" name="save">は　い</button>
          <button type="button" id="SaveButtonWarningAlertCancel" class="btn btn-primary cancel-button" name="cancel">いいえ</button>
        </div>
        </div>
      </footer>
  </div>
    <template v-if="!isFromAgenda && !isOpenVoiceWindow">
      <div class="awareness-container d-flex flex-row minutes-sticky-bar" style="justify-content: space-between;" v-bind:class="{ 'justify-content-end' : !isUseSpeech }">
        <div style="border-radius: 30px;padding-right:3px;margin:1px;"  v-if="isUseSpeech"  id="onsei_sanka_user" >
          <p style="display:inline;margin:3px;margin-left:6px;line-height: 3;">音声参加ユーザー&nbsp;:&nbsp;</p>
      
          <template v-for="(user, userid) in this.isMikeList">
            <template v-if="!user.isMike">
              <img 
              style="border-radius: 30px;border: 1px black solid;margin:1px;"
              :src="`https://ui-avatars.com/api/?name=${user.username}&background=random&size=32&rounded=false&bold=true`"
              :userid="`${userid}`"
              />
            </template>
          </template>
        </div>
      <!-- <div> -->
      <div style="border-left:solid 1px;border-color:#dee2e6;position:relative;width:330px" id="gijiroku_henshu_user">
        <p style="display:inline;margin:3px;margin-left:6px;line-height: 3;">議事録編集ユーザー&nbsp;:&nbsp;</p>
        <template v-for="userState in users">
          <img
            class="me-1"
            style="border-radius: 30px;margin:4px"
            v-tooltip.bottom="`${userState.user.name}`"
            :src="`https://ui-avatars.com/api/?name=${userState.user.name}&background=random&size=28&bold=true`"
            :userid="`${userState.userid}`"
            v-if="userState.user"
          />
        </template>
        <img
          style="border: 2px orange solid; border-radius: 30px"
          :src="`https://ui-avatars.com/api/?name=${username}&background=random&size=32&bold=true`"
          :userid="`${userid}`"
        />
      </div>
        
      </div>
    </template>
    <template v-else>
      <div class="awareness-container d-flex flex-row minutes-sticky-bar" style="justify-content: space-between;display:none;" v-bind:class="{ 'justify-content-end' : !isUseSpeech }">
        <div style="border-radius: 30px;padding-right:3px;margin:1px;"  v-if="isUseSpeech"  id="onsei_sanka_user" >
          <p style="display:inline;margin:3px;margin-left:6px;line-height: 3;">音声参加ユーザー&nbsp;:&nbsp;</p>
          <template v-for="(user, userid) in this.isMikeList">
            <template v-if="!user.isMike">
              <img 
              style="border-radius: 30px;border: 1px black solid;margin:1px;"
              :src="`https://ui-avatars.com/api/?name=${user.username}&background=random&size=32&rounded=false&bold=true`"
              :userid="`${userid}`"
              />
            </template>
          </template>
        </div>
      <!-- <div> -->
      <div style="border-left:solid 1px;border-color:#dee2e6;position:relative;width:330px;display:none;" id="gijiroku_henshu_user">
        <p style="display:inline;margin:3px;margin-left:6px;line-height: 3;">議事録編集ユーザー&nbsp;:&nbsp;</p>
        <template v-for="userState in users">
          <img
            class="me-1"
            style="border-radius: 30px;margin:4px"
            v-tooltip.bottom="`${userState.user.name}`"
            :src="`https://ui-avatars.com/api/?name=${userState.user.name}&background=random&size=28&bold=true`"
            :userid="`${userState.userid}`"
            v-if="userState.user"
          />
        </template>
        <img
          style="border: 2px orange solid; border-radius: 30px"
          :src="`https://ui-avatars.com/api/?name=${username}&background=random&size=32&bold=true`"
          :userid="`${userid}`"
        />
      </div>
        
      </div>
    </template>
    
    <!-- <div class="loading-overlay" v-if="!agenda_detail_data.sync && showflag && isLoading"> -->
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-light" role="status"></div>
      <div class="pt-3"><p class="text-white">Loading...</p></div>
    </div>
    
    	
	    <BasicInfo v-if="agenda_detail_data.sync && showflag"
	      ref="BasicInfo"
	      :username="username"
	      :awareness="yjs.wsp.awareness"
	      :basicData="basicData"
	    />
    	
	    <AgendaTable  v-if="agenda_detail_data.sync && showflag"
	      :sync="agenda_detail_data.sync"
	      ref="AgendaTable"
	      :userid="userid"
	      :username="username"
	      :awareness="yjs.wsp.awareness"
	      :agenda_detail="agenda_detail_data.agenda_detail"
        :sendTask="task"
        :sendTag="tag"
	      :inithapyo="agenda_detail_data.inithapyo"
	      :initkaiwa="agenda_detail_data.initkaiwa"
        :hapyoTemp="hapyoTemp"
        :kaiwaTemp="kaiwaTemp"
	      :csfr="csfr"
        :pre_theme="pre_theme"
        :first_minutes_state="first_minutes_state"
	      @createrighttask-emit = "refCreateRightTask"
	      @createrightdecision-emit = "refCreateRightDecision"
	      @createrightimportant-emit = "refCreateRightImportant"
	      @createrighttag-emit= "refCreateRightTag"
	      @refreshsidebar-emit = "refRefreshSideBar"
        @getHapyo = "get_minutes_info_hapyo"
        @getKaiwa = "get_minutes_info_kaiwa"
        @insertTempGijiroku = "insertTempGijirokuData"
        @dosave-emit="doSave"
	    />
		
		
	    <SpeechToText  v-if="SpeechToTextSync && showflag && isUseSpeech"
	      :sync="SpeechToTextSync"
	      ref="SpeechToText"
        :userid="userid"
	      :username="username"
	      :awareness="yjs.wsp.awareness"
        :isFromAgenda="isFromAgenda"
        :isOpenVoiceWindow="isOpenVoiceWindow"
        :csfr="csfr"
        :agenda_id="agenda_id"
        :version="version"
        :version_name="version_name"
        :url="url"
        :initSpeech = "speechTalkList"
        @getMike = "get_mikeStatus"
	    />

      <SpeechToText  v-if="SpeechToTextSync && isFromAgenda"
	      :sync="SpeechToTextSync"
	      ref="SpeechToText"
        :userid="userid"
	      :username="username"
	      :awareness="yjs.wsp.awareness"
        :isFromAgenda="isFromAgenda"
        :isOpenVoiceWindow="isOpenVoiceWindow"
        :csfr="csfr"
        :agenda_id="agenda_id"
        :url="url"
        :initSpeech = "speechTalkList"
	    />
	    
	  <SpeechToText  v-if="SpeechToTextSync && isOpenVoiceWindow"
	      :sync="SpeechToTextSync"
	      ref="SpeechToText"
        :userid="userid"
	      :username="username"
	      :awareness="yjs.wsp.awareness"
        :isFromAgenda="isFromAgenda"
        :isOpenVoiceWindow="isOpenVoiceWindow"
        :csfr="csfr"
        :agenda_id="agenda_id"
        :initSpeech = "speechTalkList"
	    />
		
    </div>

    <!-- <SiteBar v-if="agenda_detail_data.sync && showflag" -->
    <SiteBar v-if="!isLoading && showflag"
      ref="SiteBar"
      :username="username"
      :awareness="yjs.wsp.awareness"
      :agenda_detail="agenda_detail_data.agenda_detail"
      :infoHapyo="infoHapyo"
      :infoKaiwa="infoKaiwa"
    />
    
  <template v-if="!isFromAgenda && !isOpenVoiceWindow">
    <div class="fixed-bottom bg-white">
    <span class="list-group-horizontal list-group-flush footer-btn-list">
      <span class="text-center edit-mark">
        <button id="todetail" @click="doBack(false)" class="btn btn-primary btn-sm px-3 py-1 mx-1">
          <img class="mr-2 d-inline-block align-top" src="~@/assets/img/mytool_colorline.png" alt="">戻る
        </button>
      </span>
        <span class="text-center edit-mark">
          <button id="confirm-btn" @click="callSave" class="btn btn-primary btn-sm px-3 py-1 mx-1 ignore_param" >
            <img class="mr-2 d-inline-block align-top" src="~@/assets/img/mytool_colorline.png" alt="">完了
          </button>
        </span>
      </span>
    </div>
  </template>
    
    
  
  </div>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable */
import $ from "jquery";
import * as _ from "lodash";
import { DateTime } from "luxon";
import { Modal } from "bootstrap";
import YjsService from "@/services/YjsService";
import config from "@/config";
import { nanoid } from 'nanoid'

export default {
  name: "RoomView",
  components: {
  },
  data: () => ({
    csfr : null,
    exclusive_fg :null,
    objectid :null,
    yjs: null,
    roomSync: null,
    userid: null,
    username: null,
    roomId: null,
    users: [],
    pre_theme: null,
    agenda_detail_data : {} ,
    basicData : {} ,
    SpeechToTextSync:null,
    messages: [],
    showflag :false,
    infoHapyo:[],
    infoKaiwa:[],
    infoMinutes:[],
    task:[],
    tag:[],
    isFromAgenda: false,
    agenda_id:null,
    version : null,
    version_name : null,
    url : null,
    isOpenVoiceWindow : false,
    isMikeList : {},
    isUseSpeech : false,
    isLoading : true,
    speechTalkList : {},
    hapyoTemp:[],
    kaiwaTemp:[],
    isGijirokuUpdate: false,
    isSpeechUpdate: false,
    isThrough: false,
    reload: 0,
    isDoSave: false,
    isReturn : false,
    isFirst: true,
    isPopUp: true,
    isToru: true,
    first_minutes_state : "0",



  }),
  head: {
  },
  watch: {
  },
  computed: {
  },
  created() {
    
    this.roomId = this.$route.query.roomId;
    
	  var url = (window.location != window.parent.location)
      ? document.referrer
      : document.location.href;

  	  var confurl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
  	  url = url.endsWith("/") ?  url : url + "/";
	
	  if(url != confurl) {
		  this.$router.push(`/error/` + this.roomId);
	  }
    
    let room = JSON.parse(localStorage.getItem(this.roomId));
    if(room == undefined) {
      room = { username: "", lastAccess: DateTime.now(), }
    }
    localStorage.setItem(this.roomId, JSON.stringify(room));

    room = JSON.parse(localStorage.getItem(this.roomId));
    this.username = room.username;
    room.lastAccess = DateTime.now();
    localStorage.setItem(this.roomId, JSON.stringify(room));

    this.yjs = new YjsService();

    this.yjs
      .getConnectedDoc(this.roomId)
      .then((doc) => {

        this.agenda_detail_data.sync = doc.getMap("AgendaTable");
        this.roomSync = doc.getMap("roomConfig");
        this.SpeechToTextSync = doc.getMap("speechToText");
        
      })
      .catch(() => this.$router.push(`/error/${this.roomId}`));

  },
  beforeDestroy() {
    if (this.yjs) this.yjs.stopAwareness();
  },
  methods: {

    insertTempGijirokuData () {
      var _self = this;

            var linkedMinutesIdsArea = [];
            var param = [];

                $.each($("#agenda_table"), function(i, elem) {
                  var arrayData = {};
                  var array = [];
                  var table = $(elem);
                  var rowcount = 0;

                  $.each(table.find('tbody tr'), function(i, minutestablerow) {
                    if ($(minutestablerow).hasClass("agenda_row") && !$(minutestablerow).is('[dummy-row]')) {
                      rowcount++;
                      var agend_detail_id = $(minutestablerow).attr("id");
                      var rowArray = {};
                      var row = $(minutestablerow).next();
                      var gijiroku = [];

                      $(row.find(".base_minutes").not("[dummy-row]")).each(function(i, element) {
                        $(element).find("tr").find(".minutes_manager_area").each(function(i, minutesarea) {
                            var gi = {};
                            // gi["minutes_id"] = "";
                            gi["minutesid"] = $(minutesarea).find(".minutes_manager").attr("id");
                            gi["minutes"] = $(minutesarea).find(".minutes_manager").val();
                            if ( $(minutesarea).find(".minutes_manager").attr("lsize") != "NaN") {
                              gi["minutes_indent"] = $(minutesarea).find(".minutes_manager").attr("lsize");
                            } else {
                              gi["minutes_indent"] = 0;
                            }
                            gi["speaker"] = $(minutesarea).closest("tr").find(".minutes_speaker_span[speaker]").length ? $(minutesarea).closest("tr").find(".minutes_speaker_span").attr("speaker") : "";
                            gi["decision"] = $(minutesarea).closest("tr").find(".additional-info-decision i").length ? "1" : "0";
                            gi["important"] = $(minutesarea).closest("tr").find(".additional-info-important i").length ? "1" : "0";
                            gi["task"] = [];
                            
                            $(minutesarea).closest("tr").find(".table-tag-area .bi-pin-task-fill").each(function(i, taskarea) {
                              var taskId = $(minutesarea).closest("tr").find(".table-tag-area .bi-pin-task-fill").attr("taskid");
                              var $taskinfo = $(minutesarea).closest("tr").find(".dummy-tag-area .minutes-task");

                              gi["task"] = {taskname:$taskinfo.find(".disp-title-task").text(), taskorg:$taskinfo.attr("taskorg"), taskorgname:$taskinfo.attr("taskorgname"), taskorgflag:$taskinfo.attr("taskorgflag"), taskperson:$taskinfo.attr("taskperson"), taskpersonname:$taskinfo.attr("taskpersonname"), taskpersonflag:$taskinfo.attr("taskpersonflag"), taskgroup:$taskinfo.attr("taskgroup"),insertflag:$taskinfo.attr("insertFlag")};
                            });
                                
                            var $taskdetail = null;
                            var $task = null;
                            $taskdetail = $(minutesarea).find(".minutes_manager").attr("id");
                            $task = $(minutesarea).closest("tr").find('.dummy-tag-area .task-area [target='+_self.escapeSelectorString($taskdetail)+']');
                            if ($task.length) {
                              gi["task_flag"] = 1;
                              gi["task_name"] = $task.find(".disp-title-task").text();
                              gi["due_date"] = $task.find(".task_date").text();
                            } else {
                              gi["task_flag"] = 0;  
                              gi["task_name"] = $(minutesarea).find(".minutes_manager").val();
                              gi["due_date"] = "";
                            }
                                
                            gi["tag"] = [];
                            $(minutesarea).closest("tr").find(".additional-info-tag i").each(function(i, tagsarea){
                              gi["tag"].push({ tagname: $(minutesarea).closest("tr").find(".additional-info-tag i")[i].title , free_tag_flag : "1" });
                            });
                            if ($(minutesarea).closest("tr").find(".additional-info-decision i").length) {
                              gi["tag"].push( {tagname : "決定" , free_tag_flag : "0" }  );
                            }
                            if ($(minutesarea).closest("tr").find(".additional-info-important i").length) {
                              gi["tag"].push({tagname : "重要" , free_tag_flag : "0" });
                            }
                            gi["border"] =  $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).length ? "1" : "0";
                            gi["minutes_theme"] = $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).length ? $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).find(".minutestheme").attr("theme") : "";
                            var giji_content = $(minutesarea).find(".minutes_manager").val();

                            if(_self.nullToEmpty(giji_content) == "" || _self.nullToEmpty(giji_content).replace(/\r?\n/g,"") == "") {
                            }
                            
                            if ($(minutesarea).closest("table").hasClass("announcement_table")) {
                              gi["minutes_class"] = "01";
                            } else {
                              gi["minutes_class"] = "02";
                            }
                            
                            gijiroku.push(gi);
                            linkedMinutesIdsArea.push($(minutesarea));
                        })
                      });

                      rowArray["議事録"] = gijiroku;
                      rowArray["agenda_detail_id"] = agend_detail_id;
                      array.push(rowArray);
                    }
                  });

                  var master = {
                    exclusive_fg : _self.exclusive_fg,
                    objectid : _self.objectid,
                  };

                  var arrayData = {};
                  arrayData["minutes_name"] = "議事録関連";
                  arrayData["agenda_id"] = _self.$refs["BasicInfo"].getAgendaId(); 
                  arrayData["committee_id"] = _self.$refs["BasicInfo"].getCommitteeID(); 
                  arrayData["data"] = array;
                  arrayData["minutes_state"] = "1";
                  arrayData["minutes_header_id"] = _self.$refs["BasicInfo"].getMinutesHeaderId();
                  arrayData["master"] = master;
                  arrayData["csfr"] = _self.csfr;
                  param.push(arrayData);
                });

                return param;

    },

    insertSpeechText() {

      var _self = this;

      var arrayData = {};
      var tempArray = [];

      $.each($(".speechtext"), function(i, elem) {

        var row = {};
        row["textid"] = $(elem).attr("id");
        row["contents"] = $(elem).find("p.textcopy").text();
        row["userid"] = $(elem).find(".userDate").attr("user");
        row["username"] = $(elem).find("p.namearea").attr("name");
        row["startdate"] = _self.$refs["SpeechToText"].getSystemDateFormat2($(elem).find(".userDate").attr("startdt"));
        if ($(elem).hasClass("hiddenRow")) {
          row["deleteFg"] = "1";
        } else {
          row["deleteFg"] = "0";
        }
        tempArray.push(row);
      });

      arrayData["agenda_id"] = _self.agenda_id;
      arrayData["data"] = tempArray;
      arrayData["csfr"] = _self.csfr;

      return arrayData;

    },

    getIsGijirokuUpdate() {
      var _self = this;

      if (!_self.isOpenVoiceWindow && !_self.isFromAgenda) {
        if (!_self.isGijirokuUpdate) {
          _self.isGijirokuUpdate = _self.$refs["AgendaTable"].getGijirokuUpdate();
        }
      }
      return _self.isGijirokuUpdate;
    },

    getIsSpeechUpdate() {
      var _self = this;

      if (this.isUseSpeech || _self.isFromAgenda) {
        if (!_self.isSpeechUpdate) {
          _self.isSpeechUpdate = _self.$refs["SpeechToText"].getOnseiUpdate();
        }
      }
      return _self.isSpeechUpdate;
    },

    get_minutes_info_hapyo(hapyoArray) {
      this.infoHapyo = hapyoArray;

    },
    get_minutes_info_kaiwa(hapyoKaiwa) {
      this.infoKaiwa = hapyoKaiwa;
    },
    get_mikeStatus(mikeList) {
      this.isMikeList = mikeList;
    },
	  startUserLisner() {
		    this.yjs.startAwareness({
		      username: this.username,
		      listener: (changes, state) => {
		        _.each(changes.added, (c) => {
		          this.users.push({ id: c, ...state.get(c) });
		        });
		        _.each(changes.updated, (c) => {
		          let ui = _.findIndex(this.users, { id: c });
              if(ui == -1) {
                this.users.push({ id: c, ...state.get(c) });
                ui = _.findIndex(this.users, { id: c });
              }else{
  		          this.users[ui] = { id: c, ...state.get(c) };
              }
		          this.users[ui] = { id: c, ...state.get(c) };
		          $(`#cursor-${c}`).css({
		            top: this.users[ui].roomCursor.y,
		            left: this.users[ui].roomCursor.x,
		          });
		        });
		        _.each(changes.removed, (c) => {
		          this.users = _.filter(this.users, (u) => u.id !== c);
		        });
		      },
		    });
	  },
    escapeSelectorString(val){
			if(!isNaN(val)){
				return val;
			} else {
				return val.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
			}
		},
    nullToEmpty(str) {
			return (str == null) ? "" : str;
		},
    receiveMessage (event) {

      debugger
      var _self = this;
	  	var ori = event.origin.endsWith("/") ?  event.origin : event.origin + "/";
	  	var url = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";

        if (ori !== url) {
        }

        if (event.data.isSyokika != undefined && event.data.isSyokika == "1") {
          var isDo = true ;

          if (event.data.isFromAgenda) {
            if (_self.$refs["SpeechToText"] == undefined) {
              isDo = false;
            }
          } else if (event.data.isOpenVoiceWindow) {
            if (_self.$refs["SpeechToText"] == undefined) {
              isDo = false;
            }
          } else {
            // if (_self.$refs["AgendaTable"] == undefined || _self.$refs["SpeechToText"] == undefined) {
            //   isDo = false;
            // }

            if (_self.$refs["AgendaTable"] == undefined) {
              isDo = false;
            } else {
              if (event.data.audioMinutesClass == "1" && _self.$refs["SpeechToText"] == undefined) {
                isDo = false;
              }
            }
          }


          if (isDo) {
              if (_self.isToru) {
                _self.isToru = false;
                // if (event.data.audioMinutesClass == "1" && _self.$refs["SpeechToText"] != undefined) {

                // }
                _self.isLoading = false;
                // if (event.data.initialize) {
                  if (!event.data.isFromAgenda && !event.data.isOpenVoiceWindow) {
                    _self.$refs["AgendaTable"].initPage();
                  }
                  if (event.data.audioMinutesClass == "1") {
                    _self.$refs["SpeechToText"].initPage();
                  }
                  // setTimeout(async function () {
                    // _self.startUserLisner();
                  // },3000);
                // }
                if (event.data.isFromAgenda || event.data.isOpenVoiceWindow) {
                  _self.$refs["SpeechToText"].initPage();
                }

                let sendData = {doMessage : true};
                var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                window.parent.postMessage(sendData, parenturl);
              }
          } 
          return;
        }
        
        if(event.data.initialize) {
        	let room = JSON.parse(localStorage.getItem(this.roomId));
          this.userid = event.data.userid;
        	this.username = event.data.username;
        	room.username = this.username;
        	localStorage.setItem(this.roomId, JSON.stringify(room));
        	
        	this.pre_theme = event.data.pre_thema;
        	this.agenda_detail_data.agenda_detail = event.data.agenda_detail;
        	this.agenda_detail_data.inithapyo = event.data.hapyo;
        	this.agenda_detail_data.initkaiwa = event.data.kaiwa;
          this.hapyoTemp = event.data.hapyoTemp;
          this.kaiwaTemp = event.data.kaiwaTemp;
        	this.basicData.agendaDetail = event.data.agenda_detail[0];
        	this.basicData.attend = event.data.attend;
        	this.basicData.attendOther = event.data.attend_other;
        	this.basicData.budget = event.data.budget;
          this.task = event.data.task;
          this.tag = event.data.tag;
          this.csfr = event.data.csfr;
          this.exclusive_fg = event.data.exclusive_fg;
          this.objectid = event.data.objectid;
          this.startUserLisner();
          this.agenda_id = this.basicData.agendaDetail["AGENDA_ID"];
          this.version = event.data.version;
          this.version_name = event.data.version_name;
          this.url = event.data.url;

          this.first_minutes_state = event.data.agenda_detail[0]["MINUTES_STATE"];
          if (event.data.audioMinutesClass == "1") {
            this.isUseSpeech = true;
            this.speechTalkList = event.data.tempSpeechTextData
          }

          this.showflag = true;
        }

        if (event.data.isFromAgenda) {
          this.userid = event.data.userid;
        	this.username = event.data.username;
          this.csfr = event.data.csfr;
          this.exclusive_fg = event.data.exclusive_fg;
          this.agenda_id = event.data.objectid
          this.showflag = false;
          this.isFromAgenda = event.data.isFromAgenda;
          this.speechTalkList = event.data.tempSpeechTextData
        }
        
        if (event.data.isOpenVoiceWindow) {
          this.userid = event.data.userid;
          this.username = event.data.username;
          this.csfr = event.data.csfr;
          this.exclusive_fg = event.data.exclusive_fg;
          this.agenda_id = event.data.objectid
          this.showflag = false;
          this.isOpenVoiceWindow = event.data.isOpenVoiceWindow;
          this.speechTalkList = event.data.tempSpeechTextData
        }

        // setTimeout(async function () {

        // }, 5000);
      },
    minimizeAll() {
    },
    
    refCreateRightTask() {
    	this.$refs["SiteBar"].createRightTask();
    },
    
    refCreateRightDecision() {
    	this.$refs["SiteBar"].createRightDecision();
    },
    
    refCreateRightImportant() {
    	this.$refs["SiteBar"].createRightImportant();
    },
    
    refCreateRightTag() {
    	this.$refs["SiteBar"].createRightTag();
    },
    
    refRefreshSideBar() {
    	this.$refs["SiteBar"].refreshSideBar();
    },
    doBack( reload ) {
      var _self = this;
      
      // ローディング表示
      const loader = document.querySelector( '.sk-fading-circle' );
      loader.classList.remove( 'hide' );
      $('.sk-fading-circle').css('display','');

      var button = $("#todetail");
      button.attr("disabled", true);

      _self.isPopUp = false;

      Promise.resolve().then(
        function(){
          return new Promise(async function (resolve, reject) {
            var playButton = document.getElementById('playbutton');
            if ($(playButton).prop('checked')) {
              await _self.$refs["SpeechToText"].playButtonEnd(true);
            }
            resolve();
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            var param = {};
            if (_self.getIsGijirokuUpdate()) {
              param["gijiroku"] = _self.insertTempGijirokuData();
            }
            if (_self.getIsSpeechUpdate()) {
              param["mojiokoshi"] = _self.insertSpeechText();
            }
            resolve(param);
          });
        }
      ).then(
        function(param) {
          return new Promise(function (resolve, reject) {
            if (_self.getIsGijirokuUpdate() || _self.getIsSpeechUpdate()) {
              
              var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                    $.ajax({
                        type : "post",                  // HTTP通信の種類
                        url  : parenturl + "insertMinutesTempData",                 // リクエストを送信する先のURL
                        contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
                        dataType : "json",              // サーバーから返されるデータの型
                        data: JSON.stringify( param ),
                        crossDomain: true,
                        // async : false,
                        xhrFields: {
                            withCredentials: true
                        },
                        headers: {
                          'X-CSRF-TOKEN': _self.csfr,
                        },
                    }).done(function(data) {        // Ajax通信が成功した時の処理
                        resolve();
                    }).fail(function(XMLHttpRequest, textStatus, errorThrown) { // Ajax通信が失敗した時の処理
                        resolve();
                    });

            } else {
              resolve();
            }
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            // ローディング非表示
            const loader = document.querySelector( '.sk-fading-circle' );
            loader.classList.add( 'hide' );
            $('.sk-fading-circle').css('display','none');
              if(reload == undefined || reload == false) {
                _self.isThrough = true;
                let sendData = {doback : true};
                var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                window.parent.postMessage(sendData, parenturl); 
                resolve();
              } else {
                _self.isThrough = true;
                let sendData = {doReload : true};
                var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                window.parent.postMessage(sendData, parenturl);
                resolve();
              }
          })
        }
      )
    },
    doClose() {
      var _self = this;

      var button = $("#leave");
      button.attr("disabled", true);
      
      _self.isPopUp = false;

      _self.isGijirokuUpdate = _self.getIsGijirokuUpdate();
      _self.isSpeechUpdate = _self.getIsSpeechUpdate();
      _self.isThrough = true;

      Promise.resolve().then(
        function(){
          return new Promise(async function (resolve, reject) {
            var playButton = document.getElementById('playbutton');
            if ($(playButton).prop('checked')) {
              await _self.$refs["SpeechToText"].playButtonEnd(true);
            }
            resolve();
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            var param = {};
            if (_self.getIsGijirokuUpdate()) {
              param["gijiroku"] = _self.insertTempGijirokuData();
            }
            if (_self.getIsSpeechUpdate()) {
              param["mojiokoshi"] = _self.insertSpeechText();
            }
            resolve(param);
          });
        }
      ).then(
        function(param) {
          return new Promise(function (resolve, reject) {
            if (_self.getIsGijirokuUpdate() || _self.getIsSpeechUpdate()) {

              var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                    $.ajax({
                        type : "post",                  // HTTP通信の種類
                        url  : parenturl + "insertMinutesTempData",                 // リクエストを送信する先のURL
                        contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
                        dataType : "json",              // サーバーから返されるデータの型
                        data: JSON.stringify( param ),
                        crossDomain: true,
                        // async : false,
                        xhrFields: {
                            withCredentials: true
                        },
                        headers: {
                          'X-CSRF-TOKEN': _self.csfr,
                        },
                    }).done(function(data) {        // Ajax通信が成功した時の処理
                        resolve();
                    }).fail(function(XMLHttpRequest, textStatus, errorThrown) { // Ajax通信が失敗した時の処理
                        resolve();
                    });

            } else {
              resolve();
            }
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            let sendData = {doclose : true};
            var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
            window.parent.postMessage(sendData, parenturl);
            resolve();
          })
        }
      )



    },
    callSave() {
      var _self = this;
      _self.$refs["AgendaTable"].emitModal();
    },

    doSave(isTaskUpdate) {

      var _self = this;
      console.log(isTaskUpdate);

      // ローディング表示
      const loader = document.querySelector( '.sk-fading-circle' );
      loader.classList.remove( 'hide' );
      $('.sk-fading-circle').css('display','');
  
      var button = $("#confirm-btn");
      button.attr("disabled", true);

      _self.isPopUp = false;

      _self.isGijirokuUpdate = _self.getIsGijirokuUpdate();
      _self.isSpeechUpdate = _self.getIsSpeechUpdate();

      _self.isDoSave = true;
      
      let sendData = {dosave : true};
      var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
      
      _self.isThrough = true;

      Promise.resolve().then(
        function(){
          return new Promise(async function (resolve, reject) {
            var playButton = document.getElementById('playbutton');
            if ($(playButton).prop('checked')) {
              await _self.$refs["SpeechToText"].playButtonEnd(true);
            }
            // await _self.$refs["SpeechToText"].insertDummy(120);
            resolve();
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            var param = {};
            param["first_minutes_state"] = _self.first_minutes_state;
            param["isTaskUpdate"] = isTaskUpdate;
            if (_self.getIsGijirokuUpdate()) {
              param["gijiroku"] = _self.insertTempGijirokuData();
              _self.isGijirokuUpdate = true;
            }
            if (_self.getIsSpeechUpdate()) {
              param["mojiokoshi"] = _self.insertSpeechText();
              _self.isSpeechUpdate = true;
            }
            resolve(param);
          });
        }
      ).then(
        function(param) {
          return new Promise(function (resolve, reject) {
            if (_self.getIsGijirokuUpdate() || _self.getIsSpeechUpdate()) {

              var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                    $.ajax({
                        type : "post",                  // HTTP通信の種類
                        url  : parenturl + "insertMinutesTempData",                 // リクエストを送信する先のURL
                        contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
                        dataType : "json",              // サーバーから返されるデータの型
                        data: JSON.stringify( param ),
                        crossDomain: true,
                        // async : false,
                        xhrFields: {
                            withCredentials: true
                        },
                        headers: {
                          'X-CSRF-TOKEN': _self.csfr,
                        },
                    }).done(function(data) {        // Ajax通信が成功した時の処理
                        resolve();
                    }).fail(function(XMLHttpRequest, textStatus, errorThrown) { // Ajax通信が失敗した時の処理
                        resolve();
                    });
            } else {
                  resolve();
            }
          });
        }
      ).then(
        function() {
          return new Promise(function (resolve, reject) {
            _self.$nextTick(() => {
              var linkedMinutesIdsArea = [];

              $.each($("#agenda_table"), function(i, elem) {
                var arrayData = {};
                var array = [];
                var table = $(elem);
                var rowcount = 0;
            
                $.each(table.find('tbody tr'), function(i, minutestablerow) {
                  if ($(minutestablerow).hasClass("agenda_row") && !$(minutestablerow).is('[dummy-row]')) {
                    rowcount++;
                    var agend_detail_id = $(minutestablerow).attr("id");
                    var rowArray = {};
                    var row = $(minutestablerow).next();
                    var gijiroku = [];
              
                    $(row.find(".base_minutes").not("[dummy-row]")).each(function(i, element) {
                      $(element).find("tr").find(".minutes_manager_area").each(function(i, minutesarea) {
                          var gi = {};
                          // gi["minutes_id"] = "";
                          gi["minutesid"] = $(minutesarea).find(".minutes_manager").attr("id");
                          gi["minutes"] = $(minutesarea).find(".minutes_manager").val();
                          if ( $(minutesarea).find(".minutes_manager").attr("lsize") != "NaN") {
                            gi["minutes_indent"] = $(minutesarea).find(".minutes_manager").attr("lsize");
                          } else {
                            gi["minutes_indent"] = 0;
                          }
                          gi["speaker"] = $(minutesarea).closest("tr").find(".minutes_speaker_span[speaker]").length ? $(minutesarea).closest("tr").find(".minutes_speaker_span").attr("speaker") : "";
                          gi["decision"] = $(minutesarea).closest("tr").find(".additional-info-decision i").length ? "1" : "0";
                          gi["important"] = $(minutesarea).closest("tr").find(".additional-info-important i").length ? "1" : "0";
                          gi["task"] = [];
                          
                          $(minutesarea).closest("tr").find(".table-tag-area .bi-pin-task-fill").each(function(i, taskarea) {
                            var taskId = $(minutesarea).closest("tr").find(".table-tag-area .bi-pin-task-fill").attr("taskid");
                            var $taskinfo = $(minutesarea).closest("tr").find(".dummy-tag-area .minutes-task");

                            gi["task"] = {taskname:$taskinfo.find(".disp-title-task").text(), taskorg:$taskinfo.attr("taskorg"), taskorgname:$taskinfo.attr("taskorgname"), taskorgflag:$taskinfo.attr("taskorgflag"), taskperson:$taskinfo.attr("taskperson"), taskpersonname:$taskinfo.attr("taskpersonname"), taskpersonflag:$taskinfo.attr("taskpersonflag"), taskgroup:$taskinfo.attr("taskgroup"),insertflag:$taskinfo.attr("insertFlag")};
                          });
                              
                          var $taskdetail = null;
                          var $task = null;
                          $taskdetail = $(minutesarea).find(".minutes_manager").attr("id");
                          $task = $(minutesarea).closest("tr").find('.dummy-tag-area .task-area [target='+_self.escapeSelectorString($taskdetail)+']');
                          if ($task.length) {
                            gi["task_flag"] = 1;
                            gi["task_name"] = $task.find(".disp-title-task").text();
                            gi["due_date"] = $task.find(".task_date").text();
                          } else {
                            gi["task_flag"] = 0;  
                            gi["task_name"] = $(minutesarea).find(".minutes_manager").val();
                            gi["due_date"] = "";
                          }
                              
                          gi["tag"] = [];
                          $(minutesarea).closest("tr").find(".additional-info-tag i").each(function(i, tagsarea){
                            gi["tag"].push({ tagname: $(minutesarea).closest("tr").find(".additional-info-tag i")[i].title , free_tag_flag : "1" });
                          });
                          if ($(minutesarea).closest("tr").find(".additional-info-decision i").length) {
                            gi["tag"].push( {tagname : "決定" , free_tag_flag : "0" }  );
                          }
                          if ($(minutesarea).closest("tr").find(".additional-info-important i").length) {
                            gi["tag"].push({tagname : "重要" , free_tag_flag : "0" });
                          }
                          gi["border"] =  $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).length ? "1" : "0";
                          gi["minutes_theme"] = $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).length ? $(minutesarea).closest("tbody").find("#theme_"+$(minutesarea).find(".minutes_manager").attr("id")).find(".minutestheme").attr("theme") : "";
                          var giji_content = $(minutesarea).find(".minutes_manager").val();
            
                          if(_self.nullToEmpty(giji_content) == "" || _self.nullToEmpty(giji_content).replace(/\r?\n/g,"") == "") {
                            if(gi["speaker"] == "" && gi["decision"] == "0" && gi["important"] == "0" && ( gi["task"].length != undefined && gi["task"].length == 0 ) &&  gi["tag"].length == 0 && gi["minutes_theme"] == "") {
                              return;
                            }
                          }
                          
                          if ($(minutesarea).closest("table").hasClass("announcement_table")) {
                            gi["minutes_class"] = "01";
                          } else {
                            gi["minutes_class"] = "02";
                          }
                          
                          gijiroku.push(gi);
                          linkedMinutesIdsArea.push($(minutesarea));
                      })
                    });
              
                    rowArray["議事録"] = gijiroku;
                    rowArray["agenda_detail_id"] = agend_detail_id;
                    array.push(rowArray);
                  }
                });

                var master = {
                  exclusive_fg : _self.exclusive_fg,
                  objectid : _self.objectid,
                };

                var arrayData = {};
                arrayData["minutes_name"] = "議事録関連";
                arrayData["agenda_id"] = _self.$refs["BasicInfo"].getAgendaId(); 
                arrayData["committee_id"] = _self.$refs["BasicInfo"].getCommitteeID(); 
                arrayData["data"] = array;
                arrayData["minutes_state"] = "1";
                arrayData["minutes_header_id"] = _self.$refs["BasicInfo"].getMinutesHeaderId();
                arrayData["master"] = master;
                arrayData["first_minutes_state"] = _self.first_minutes_state;
                arrayData["isTaskUpdate"] = isTaskUpdate;


                var param = [];
                param.push(arrayData);
                console.log(arrayData)

                $.ajax({
                    type : "post",                  // HTTP通信の種類
                    url  : parenturl + "insertMinutesData",                 // リクエストを送信する先のURL
                    contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
                    dataType : "json",              // サーバーから返されるデータの型
                    data:JSON.stringify(param),
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    headers: {
                      'X-CSRF-TOKEN': _self.csfr,
                    },
                }).done(function(data) {        // Ajax通信が成功した時の処理
                    resolve();
                }).fail(function(XMLHttpRequest, textStatus, errorThrown) { // Ajax通信が失敗した時の処理
                    resolve();
                });
              });
            });
          })
        }
      ).then(
        function(){
          return new Promise(async function (resolve, reject) {
            // ローディング非表示
            const loader = document.querySelector( '.sk-fading-circle' );
            loader.classList.add( 'hide' );
            $('.sk-fading-circle').css('display','none');
            window.parent.postMessage(sendData, parenturl);
            resolve();
          });
        }
      )
  },
},
  mounted () {
    var _self = this;

    $(document).on('click','#leave', function(e) {
         e.preventDefault(); 
        _self.doClose(true);
        return false;
    });

    window.addEventListener('keydown',
    e => {
      if(e.key == "F5") {
        if (_self.isReturn) {
          return;
        }
        _self.isReturn = true;
        Promise.resolve().then(
          async function(){
            return new Promise( async function (resolve, reject) { 
            var $focus = $(':focus')
            if ($focus.length && $focus.hasClass("minutes_manager")) {
              await $focus.blur();
              resolve();
            } else {
              resolve();
            }
          })
        }).then(
          async function(){
            return new Promise( async function (resolve, reject) {
              e.preventDefault();
              _self.doBack(true);
              resolve();
              return;
          })
        })

      }
    });
    
	  window.addEventListener('message', this.receiveMessage)
	    
	    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
	    	const $elem = $("#" + collapseId + "-target");
	    	this.$collapseAction($elem, isJustShown);
	    })
	    
	    
	    let sendData = {}
	    sendData["resize"] = true;
	    sendData["height"] = document.body.scrollHeight;
	    window.parent.postMessage(sendData, config.VUE_APP_PARENT_URL);
      
			$(window).on('beforeunload', function(e) { 

        let sendData = {}

        Promise.resolve().then( async function(){
        return new Promise(async function (resolve, reject) {
      
          _self.isGijirokuUpdate = _self.getIsGijirokuUpdate();
          _self.isSpeechUpdate = _self.getIsSpeechUpdate();

          var playButton = document.getElementById('playbutton');

          if (!_self.isThrough) {
            if (_self.getIsGijirokuUpdate() || _self.getIsSpeechUpdate() || $(playButton).prop('checked')) {
              // ローディング表示
              const loader = document.querySelector( '.sk-fading-circle' );
              loader.classList.remove( 'hide' );
              $('.sk-fading-circle').css('display','');

              Promise.resolve().then(
                async function(){
                  return new Promise( async function (resolve, reject) { 
                  var $focus = $(':focus')
                  if ($focus.length && $focus.hasClass("minutes_manager")) {
                    await $focus.blur();
                    resolve();
                  } else {
                    resolve();
                  }
                })
              }).then(
                async function(){
                  return new Promise( async function (resolve, reject) {
                    var playButton = document.getElementById('playbutton');
                    if ($(playButton).prop('checked')) {
                      sendData["onsei"] = await _self.$refs["SpeechToText"].playButtonEnd(false);
                    }             
                    resolve();
                })
              }).then(
                function() {
                  return new Promise(function (resolve, reject) {
                    var param = {};
                    if (_self.getIsGijirokuUpdate()) {
                      param["gijiroku"] = _self.insertTempGijirokuData();
                      _self.isGijirokuUpdate = true;
                    }
                    if (_self.getIsSpeechUpdate()) {
                      param["mojiokoshi"] = _self.insertSpeechText();
                      _self.isSpeechUpdate = true;
                    }
                    resolve(param);
                  });
                }
              ).then(
                function(param) {
                  return new Promise(function (resolve, reject) {
                    if (_self.isGijirokuUpdate || _self.isSpeechUpdate) {
                      _self.isGijirokuUpdate = false;
                      _self.isSpeechUpdate = false;
                      
                      sendData["param"] = param;

                      if (_self.isPopUp) {
                        var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                        $.ajax({
                            type : "post",                  // HTTP通信の種類
                            url  : parenturl + "insertMinutesTempData",                 // リクエストを送信する先のURL
                            contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
                            dataType : "json",              // サーバーから返されるデータの型
                            data: JSON.stringify( param ),
                            crossDomain: true,
                            // async : false,
                            xhrFields: {
                                withCredentials: true
                            },
                            headers: {
                              'X-CSRF-TOKEN': _self.csfr,
                            },
                        }).done(function(data) {        // Ajax通信が成功した時の処理
                            // ローディング非表示
                            const loader = document.querySelector( '.sk-fading-circle' );
                            loader.classList.add( 'hide' );
                            $('.sk-fading-circle').css('display','none');
                            resolve();
                        }).fail(function(XMLHttpRequest, textStatus, errorThrown) { // Ajax通信が失敗した時の処理
                          // ローディング非表示
                          const loader = document.querySelector( '.sk-fading-circle' );
                          loader.classList.add( 'hide' );
                          $('.sk-fading-circle').css('display','none');
                            resolve();
                        });
                      }
                      resolve();
                    } else {
                      resolve();
                    }
                  });
                }
              ).then(
                function() {
                  return new Promise(async function (resolve, reject) {
                    if (_self.yjs) await _self.yjs.stopAwareness();
                    resolve();
                })
                }
              ).then(
                function() {
                  return new Promise(async function (resolve, reject) {
                    sendData["doBeforeunload"] = true;
                    var parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
                    window.parent.postMessage(sendData, parenturl); 
                    resolve();
                  })
                }
              )
            } else {
              if (_self.yjs) await _self.yjs.stopAwareness();
            }
          } else {
            if (_self.yjs) await _self.yjs.stopAwareness();
            window.removeEventListener('message', _self.receiveMessage)
          }
        })
          });

        if (_self.isPopUp) {
          e.preventDefault();
          e.returnValue = '';
          return ''
        }
      })
  },
};
</script>

<style scoped>
.room-container {
  height: 100%;
}

#bg-playback-container {
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
}

#bg-playback {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (min-aspect-ratio: 16/9) {
  #bg-playback {
    height: 86.25vw !important;
  }
}
@media (max-aspect-ratio: 16/9) {
  #bg-playback {
    width: 177.78vh !important;
    height: 120% !important;
  }
}

.header_row {
  position: relative;
}

.user-cursor {
  position: absolute;
    z-index: 99998;
    transform: translate(-90%, -16%);
    max-width: 200px;
}

.titlebar-container {
  position: absolute;
  z-index: 997;
  top: 10px;
  left: 25px;
}

.toolbar-container {
  position: absolute;
  z-index: 995;
  display: flex;
  align-items: center;
  left: 10px;
  top: 50%;
  transform: translate(0, -50%);
}

.awareness-container {
}


i.bi {
  font-size: 1.5em;
}

.app-button {
  display: flex;
  flex-direction: column;
}

.app-title {
  font-size: 0.6em;
  text-transform: uppercase;
  font-weight: bold;
}

.loading-overlay {
  background-color: #222;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
}

.user-cursor > span {
  border: 1px #0dcaf0 solid;
  border-radius: 5px;
  background: white;
  font-size: 0.6em;
  font-weight: bold;
  text-transform: uppercase;
  padding: 3px 3px 0px 3px;
}

.awareness-container {
	background: #f7f7f7;
}

.fixed-top-alert2 {
	z-index: 1200;
	position: fixed;
	top: 30px;
	left: 50%;
	transform: translateX(-50%);
	-webkit-transform: translateX(-50%);
	-ms-transform: translateX(-50%);
}

.fixed-top-alert3 {
    z-index: 1200;
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
}
.alert-warning {
    width: 30%;
}
.container {
    padding-top: 10px;
}
.cancel-button {
    margin-left: 10%;
}
</style>